// extracted by mini-css-extract-plugin
export default {"metadata__category_name":"CategorizedList_metadata__category_name__s4Bz5","metadata__category_list":"CategorizedList_metadata__category_list__id6XC"};